import {Component} from "react"
import EventAdaptingStateHandler from "src/states/EventAdaptingStateHandler"
import ValuationDescription from "src/components/layout/ValuationDescription"
import ApiHandler from "src/api/ApiHandler"
import ErrorHandler from "src/components/errors/ErrorHandler"
import UserVisibleErrorStoringDecorator from "src/components/decorators/UserErrorStoringDecorator"
import StateConstants from "src/states/StateContstants"
import Loader from "src/components/general/Loading"
import ValuationLoader from "src/components/general/ValuationLoader"
import Helmet from "react-helmet"
import SearchForm from "src/components/search/SearchForm"
import ExplanationText from "src/components/layout/ExplanationText"
import navigationService from "src/navigation/NavigationService"
import "./Search.css"


class SearchPage extends Component<any> {
    stateHandler : EventAdaptingStateHandler
    apiHandler: ApiHandler
    errorHandler: ErrorHandler
    state: any
    loader: Loader

    constructor(props: any) {
        super(props)
        this.stateHandler = props.stateHandler
        this.apiHandler = props.apiHandler
        this.errorHandler = props.errorHandler
        this.loader = props.loader
        this.state = {
            isLoading: false,
        }
        this.stateHandler.addListener(StateConstants.IS_LOADING, (state: any) => {
            this.setState((prevState) => ({
                ...prevState,
                isLoading: state
            }))
        })
        this.stateHandler.addListener(StateConstants.ERROR, () => {
            this.setState({})
        })
    }

    @UserVisibleErrorStoringDecorator()
    async search(event: any) {
        event.preventDefault();
        let address = this.stateHandler.get(StateConstants.ADDRESS_STATE)
        if (address === undefined || address === "") {
            return
        }

        let input = {"address": address}

        let foundAddress = await this.apiHandler.findAddress(input)
        let id = foundAddress["gi"]
        this.redirectToValuationPage(id)
    }

    redirectToValuationPage(id: string) {
        navigationService.navigateToValuation(id, this.apiHandler)
    }

    render() {
        const { isLoading } = this.state

        if (isLoading) {
            return <ValuationLoader />
        }

        return (
            <div>
                <Helmet>
                    <title>{`Value your home`}</title>
                    <meta name="description" content="Enter your address and hit search. HomeIndex is Ireland's instant house valuation tool"/>
                    <link rel="canonical" href="https://homeindex.ie/"/>
                </Helmet>
                {this.errorHandler.render(this.stateHandler.get("error"), {
                    onDismiss: () => this.stateHandler.set(StateConstants.ERROR, null)
                })}
                <div className='valuations-home-page'>
                    <img
                        src="/home_page_image_1920.webp"
                        alt=""
                        className="valuations-home-page-bg"
                        fetchPriority="high"
                        decoding="async"
                    />
                    <ValuationDescription/>
                    <SearchForm stateHandler={this.stateHandler} apiHandler={this.apiHandler} border={false}/>
                    <ExplanationText/>
                </div>
            </div>
        )
    }
}

export default SearchPage
